import React, { useRef } from "react"
import { Formik, Form } from "formik"
import {
  Button,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  styled,
} from "@mui/material"

import { kitchenAreaSchema } from "../../../../../utils/yupValidators"

// form initial values
const getInitialValues = (data) => {
  // creation
  if (!data) {
    return {
      name: "",
    }
  }

  // edition
  return {
    name: data.kitchenArea.name,
  }
}

const StyledDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    width: 500,
    padding: 10
  },
})

export const KitchenAreaFormModal = (props) => {
  const { onClose, open, onConfirm, kitchenArea, isEdition } = props

  const formikRef = useRef(null)

  const handleConfirm = () => {
    formikRef.current.submitForm()
  }

  const handleSubmit = (values) => {
    onConfirm(values)
    onClose()
  }

  const handleCancel = () => {
    onClose()
  }

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title" sx={{ pb: 0 }}>
         {isEdition ? "Éditer un atelier" : "Ajouter un atelier"}
      </DialogTitle>
      <DialogContent sx={{ mt: 1 }}>
        <Formik
          innerRef={formikRef}
          onSubmit={handleSubmit}
          validationSchema={kitchenAreaSchema}
          initialValues={getInitialValues(kitchenArea)}
        >
          {({ values, handleChange, handleBlur, errors }) => {
            return (
              <Form>
                <TextField
                  variant="standard"
                  label="Nom de l'atelier"
                  name="name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                  error={!!errors.name}
                  helperText={errors.name}
                  fullWidth
                />
              </Form>
            )
          }}
        </Formik>
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
        <Button onClick={handleCancel} color="primary">
          Annuler
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained">
          Enregistrer
        </Button>
      </DialogActions>
    </StyledDialog>
  )
}

export default KitchenAreaFormModal
